import React, { memo, useEffect, useState } from "react";

import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import blogsStyle from "assets/jss/trip-kit/views/sectionsSections/blogsStyle.js";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useMediaQuery }  from "react-responsive";
const useStyles = makeStyles(blogsStyle);

const RecommendContentsItem = memo(({content,lang}) => {
  const [type, setType] = useState("");
  const isPad = useMediaQuery({
    query : "(min-width: 600px) and (max-width: 1199px)"
  })
  const isMobile = useMediaQuery({
    query : "(max-width: 599px)"
  })
  useEffect(() =>{
   
    if(content.contenttypeid ==12|| content.contenttypeid ==76){        //관광지
      setType("travel");
    }else if(content.contenttypeid ==14 || content.contenttypeid ==78){  //문화시설
      setType("culture");
    } else if(content.contenttypeid ==39 || content.contenttypeid ==82){ //음식
      setType("food");
    } else if(content.contenttypeid ==32 || content.contenttypeid ==80){ //숙박
      setType("hotel");
    } else if(content.contenttypeid ==38 || content.contenttypeid ==79){ //쇼핑
      setType("shopping");
    } else if(content.contenttypeid ==15 || content.contenttypeid ==85){ //축제/공연
      setType("festival");
    } else if(content.contenttypeid ==28 || content.contenttypeid ==75){ //레포츠
      setType("leisure");
    } else if(content.contenttypeid ==77 ){ //교통
      setType("transportation");
    } else if(content.contenttypeid ==25 ){ //여행코스
      setType("course");
    }
    
  },[content]);
  const subStrTxt = (txt,len) => {
    if (txt.length > len) {
      txt = txt.substr(0, len) + '...';
    }
    return txt;
  }
   
    const classes = useStyles();
    return (
      <GridItem xs={12} sm={4} md={4}style={{paddingBottom:"10px"}}>
        <Card plain blog>  
          
          <Link to={`/${type}/${content.contenttypeid}/${content.contentid}?local=${lang}`}>
              <CardHeader plain image>
                <LazyLoadImage width={"100%"} height={"150px"} effect="blur" style={{height:"150px"}} src={content.firstimage ? content.firstimage.replace('http:', 'https:') : "https://www.tripcheckiner.com/no-image-icon.jpg"} alt={content.title}/>

              </CardHeader>
              {
                <CardBody plain>
                <h4 className={classes.cardTitle2} style={{fontSize:"14px"}}>{content.title ?subStrTxt(content.title,isPad ? 18 : isMobile ? 60: 45) : ""}</h4>
                <h6 style={{color:"#a2a2a2"}}>{content.addr1 ? subStrTxt(content.addr1,isPad ? 18 : isMobile ? 40 : 28) : ""}</h6>
              </CardBody>
              }
          </Link>
        </Card>
      </GridItem>
    );
});

export default RecommendContentsItem;